import * as format from "@/service/formatTemplate.js";
export default {
    namespaced: true,
    state: {
        rules: {
            template_name: [
                { required: true, message: "请输入任务名称", trigger: "blur" },
            ],
            template_type: [
                { required: true, message: "请选择模板类型", trigger: "change" },
            ],
            template_describe: [
                { required: true, message: "请输入模板描述", trigger: "blur" },
            ],
        },
    },
    actions: {
        // 获取格式模板列表
        getFormatListSto({ commit }, datas) {
            return format.getFormatListSer(datas);
        },
        //添加格式模板
        saveFormatSto({ commit }, datas) {
            return format.saveFormatSer(datas);
        },
        //删除格式模板
        deleteFormatSto({ commit }, datas) {
            return format.deleteFormatSer(datas);
        },
        // 获取格式模板详情
        getFormatSto({ commit }, datas) {
            return format.getFormatSer(datas);
        },
        //修改格式模板
        editFormatSto({ commit }, datas) {
            return format.editFormatSer(datas);
        },
    },
};